import React, { useState, useEffect } from 'react'
import { EmptyPlaceholder } from '../../../../components/placeholder';
import { priceFormat } from '../../../../utils/common';
import './index.less'
const CHARGE_CDN = 'https://s.xiaopeng.com/xp-charge/mini'

const ShortMemberGoodslist = ({ list, type, onChange, active }: { list: any[]; type?: 'coupon_pack' | 'value_card'; onChange: (data) => void; active: any }) => {

  if (!type) {
    return <></>
  }
  return <div
    className='short-good-item-list-wrap'
    onScroll={(e) => {
      e.preventDefault()
      e.stopPropagation()
    }}>
    <div
      className='good-item-list'
      style={list.length === 1 ? { overflow: 'hidden' } : {}}
      onScroll={(e) => {
        e.preventDefault()
        e.stopPropagation()
      }}
    >
      {
        list.length
          ?
          list.map((listItem, index) => {
            return <div
              className={
                `good-item
              ${type === 'coupon_pack' ? `coupon-pack-good-item${listItem?.key === active?.key ? '-active' : ''}` : ''} 
              ${type === 'value_card' ? `value-card-good-item${listItem?.key === active?.key ? '-active' : ''}` : ''}
              ${list.length === 1 ? `full-width` : ''}
              `
              }
              onClick={() => onChange(listItem)}
              key={`short-good-${listItem?.spu}-${index}`}
              onScroll={(e) => {
                e.preventDefault()
                e.stopPropagation()
              }}
            >
              {
                type === 'coupon_pack'
                &&
                <div className='good-content'>
                  <div className='good-content-title'>
                    VIP券包
                    <div className='good-title-wrap'>
                      <div
                        className={`heavy-text ${list.length === 1 ? 'heavy-text-width' : ''}`}
                      >
                        {listItem?.mainTitle || '--'}
                      </div>
                    </div>
                  </div>
                  <div className='good-price-wrap'>
                    <div className='big-heavy-text-unit'>¥</div>
                    <div className='big-heavy-text'>{listItem?.showDiscountBuy ? priceFormat(listItem?.discountBuyPrice) : priceFormat(listItem?.salePrice)}</div>
                    {!!listItem?.showDiscountBuy && <div className='grey-line-price-text'>¥{priceFormat(listItem?.salePrice)}</div>}
                  </div>
                </div>
              }
              {
                type === 'value_card'
                &&
                <div className='good-content'>
                  <div className='good-content-title'>
                    VIP储值卡
                    <div className='good-title-wrap'>
                      <div
                        className={`value-title ${list.length === 1 ? 'value-title-width' : ''}`}
                      >
                        {listItem?.mainTitle}
                      </div>
                    </div>
                  </div>
                  <div className='good-price-wrap'>
                    <div className='big-heavy-text-unit'>¥</div>
                    <div className='big-heavy-text'>{listItem?.showDiscountBuy ? priceFormat(listItem?.discountBuyPrice) : priceFormat(listItem?.salePrice)}</div>
                    {!!listItem?.showDiscountBuy && <div className='grey-line-price-text'>¥{priceFormat(listItem?.salePrice)}</div>}
                  </div>
                </div>
              }
              <div className='good-extra-desc'>
                {listItem?.subTitle}
              </div>
            </div>
          })
          :
          <div></div>
      }
    </div>
  </div>
}




export default ShortMemberGoodslist